// First, before the router reads the address: a sign-in coming back carries
// the entry in it, and `entry.ts` takes it out again.
import "./lib/entry";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App, { preloadCurrentPage } from "./App";
import { currentLocale } from "./lib/router";
import { loadMessages, type Locale } from "./i18n";
import { markTextBoundaries } from "./lib/prerender-marks";
import "./styles/index.css";

const root = document.getElementById("root")!;
markTextBoundaries(root);
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// What the first render needs, fetched in parallel: the language's strings, and the chunk of the
// page the address names. Hydration matches the frozen HTML node by node, so both have to be in
// hand before it starts; until then the frozen page is what the visitor is looking at.
const ready = Promise.all([
  loadMessages(currentLocale() as Locale),
  preloadCurrentPage(),
]).catch(() => undefined);

if (root.hasChildNodes()) {
  // A prerendered page: keep the frozen HTML on screen and attach to it, rather than
  // clearing it and drawing the page again.
  void ready.then(() => hydrateRoot(root, app));
} else {
  void ready.then(() => createRoot(root).render(app));
}
